import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../setup';
import { createStyles, withStyles } from '@mui/styles';
import { FormType } from '../../../constants/constants';
import { resetSellers } from '../../../reducers/sellerReducer';
import SellerForm from './sellerForm';

interface IAddSellerProps {
    classes: any;
    theme: Theme;
    match: any;
    sellers: any;
    steps: Array<number>;
    sellerId?: number;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetSellers: () => dispatch(resetSellers())
});

const mapStoreToProps = (store: RootState, ownProps: IAddSellerProps) => {
    return {
        sellerId: ownProps.match.params?.sellerId ? Number(ownProps.match.params?.sellerId) : undefined
    };
};

class AddSeller extends Component<IAddSellerProps> {
    componentWillUnmount() {
        resetSellers();
    }

    render() {
        const { classes, steps, sellerId, type } = this.props;

        return (
            <Card className={classes.root}>
                <CardContent className={classes.cardContent}>
                    <SellerForm sellerId={sellerId} steps={steps} type={type} />
                </CardContent>
            </Card>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddSeller));